<template>
  <div class="at-a-glance-legend" :class="fromReport ? 'report' : ''">
    <div
      class="at-a-glance-legend__header"
      @click="state.open = !state.open"
      :class="fromReport ? 'no-curve' : state.open ? 'open' : ''"
    >
      <div class="at-a-glance-legend__title">Legend</div>
      <div v-if="!fromReport" class="at-a-glance-legend__icon">
        <IconChevronCircleDown :isActive="state.open" />
      </div>
    </div>
    <div
      class="at-a-glance-legend__content"
      :class="fromReport ? 'no-curve' : state.open ? 'expand' : 'hide'"
    >
      <div class="at-a-glance-legend__text" :class="fromReport ? 'report' : ''">
        <div class="at-a-glance-legend__data-trend">
          <strong>Data Trend</strong>
          - 3MMT, 12MMT, 3MMA, or 12MMT data trend value
        </div>
        <div class="at_a-glance-legend__rate-of-change">
          <strong>Rate-of-Change</strong>
          - 3/12 or 12/12 monthly rate-of-change value
        </div>
      </div>
      <div
        class="at-a-glance-legend__graphs"
        :class="fromReport ? 'report' : ''"
      >
        <div
          class="at-a-glance-legend__roc-graph"
          :class="fromReport ? 'report' : ''"
        >
          <img :src="asset('/images/product/trendsreport/roc-graph.png')" />
          <div class="roc-text">Rate-of-Change Trend Graph</div>
        </div>
        <div
          class="at-a-glance-legend__dt-graph"
          :class="fromReport ? 'report' : ''"
        >
          <img :src="asset('/images/product/trendsreport/dt-graph.png')" />
          <div class="roc-text">Data Trend Graph</div>
        </div>
      </div>
      <div
        class="at-a-glance-legend__phases"
        :class="fromReport ? 'report' : ''"
      >
        <div
          class="at-a-glance-legend__phase-image"
          :class="fromReport ? 'report' : ''"
        >
          <img
            :src="asset('/images/product/trendsreport/phase-a-legend.png')"
          />
        </div>
        <div
          class="at-a-glance-legend__phase-image"
          :class="fromReport ? 'report' : ''"
        >
          <img
            :src="asset('/images/product/trendsreport/phase-b-legend.png')"
          />
        </div>
        <div
          class="at-a-glance-legend__phase-image"
          :class="fromReport ? 'report' : ''"
        >
          <img
            :src="asset('/images/product/trendsreport/phase-c-legend.png')"
          />
        </div>
        <div
          class="at-a-glance-legend__phase-image"
          :class="fromReport ? 'report' : ''"
        >
          <img
            :src="asset('/images/product/trendsreport/phase-d-legend.png')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { ref, onMounted, reactive, watch } from 'vue';
  import IconChevronCircleDown from '~/components/icon/IconChevronCircleDown.vue';

  export default {
    name: 'AtAGlanceLegend',
    components: {
      IconChevronCircleDown,
    },
    props: {
      fromReport: {
        type: Boolean,
        default: false,
      },
      imagespath: {
        type: String,
        required: false,
      },
    },
    setup(props) {
      const assetUrl = ref('');

      const state = reactive({
        open: true,
      });

      onMounted(() => {
        assetUrl.value = document
          .getElementById('main-page-wrapper')
          .getAttribute('data-asset-url');
        if (!props.fromReport && localStorage.getItem('aag-legend-state')) {
          state.open = JSON.parse(localStorage.getItem('aag-legend-state'));
        }
      });

      const asset = (path) => {
        if (assetUrl.value && assetUrl.value) {
          return `${assetUrl.value.replace(/\/$/, '')}${path}`;
        }
        return props.imagespath+path;
      };

      watch(
        () => state.open,
        (newVal) => {
          localStorage.setItem('aag-legend-state', JSON.stringify(newVal));
        },
      );

      return {
        asset,
        state,
      };
    },
  };
</script>

<style lang="scss" scoped>
  .at-a-glance-legend {
    width: 100%;
    margin-bottom: 1rem;
    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: var(--itr-green-mid);
      padding: 10px 20px;
      border-radius: 10px;
      cursor: pointer;
      transition: ease-in-out 100ms;
    }
    &__header.open {
      border-radius: 10px 10px 0 0;
    }
    &__header.no-curve {
      border-radius: 0;
    }

    &__title {
      font-weight: bold;
      font-size: 20px;
      color: var(--itr-white);
    }
    &__content {
      border-radius: 0 0 10px 10px;
      border-left: 1px solid var(--itr-tr-grey);
      border-right: 1px solid var(--itr-tr-grey);
      border-bottom: 1px solid var(--itr-tr-grey);
      padding: 16px;
      display: flex;
      flex-direction: column;
      @include screen-sm {
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
        flex-wrap: wrap;
      }
      @include screen-md {
        flex-wrap: nowrap;
        align-items: center;
      }
      @include screen-xl {
        flex-wrap: wrap;
      }
      @include screen-xxl {
        flex-wrap: nowrap;
        align-items: flex-start;
      }
    }
    &__content.no-curve {
      border-radius: 0;
    }
    &__content.expand {
      height: 100%;
      visibility: visible;
      transition: ease-in-out 150ms;
      opacity: 1;
    }
    &__content.hide {
      height: 0px;
      visibility: hidden;
      overflow: hidden;
      opacity: 0;
    }
    &__text {
      font-size: 14px;
      @include screen-sm {
        width: 53%;
      }
      @include screen-md {
        width: 28%;
      }
      @include screen-xl {
        order: 3;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 1.5rem;
      }
      @include screen-xxl {
        order: 1;
        width: 24%;
        flex-direction: column;
        margin-top: 0;
      }
    }
    &__text.report {
      order: 1;
      flex-direction: column;
      width: 25%;
    }
    &__data-trend {
      margin-bottom: 1rem;
      @include screen-xl {
        margin-bottom: 0;
        margin-right: 16px;
      }
      @include screen-xxl {
        margin-bottom: 1rem;
        margin-right: 0;
      }
    }
    &__graphs {
      display: flex;
      align-items: flex-start;
      justify-content: center;
      text-align: center;
      font-size: 14px;
      line-height: 18px;
      @include screen-sm {
        width: 43%;
      }
      @include screen-md {
        flex-direction: column;
        align-items: center;
        width: 23%;
      }
      @include screen-xl {
        order: 1;
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-between;
        width: 30%;
      }
      @include screen-xxl {
        width: 21%;
        order: 2;
      }
    }
    &__graphs.report {
      order: 2;
      width: 25%;
      flex-direction: row;
      align-items: flex-start;
      justify-content: space-between;
    }
    &__roc-graph {
      width: 45%;
      margin: 1rem;
      @include screen-sm {
        margin: 0 8px;
      }
      @include screen-md {
        width: unset;
      }
      @include screen-xl {
      }
      @include screen-xxl {
        width: 45%;
      }
      img {
        width: 98px;
        margin-bottom: 16px;
        @include screen-sm {
        }
      }
    }
    &__roc-graph.report {
      img {
        width: 80px;
      }
    }
    &__dt-graph {
      width: 45%;
      margin: 1rem;
      @include screen-sm {
        margin: 0 8px;
      }
      @include screen-md {
        width: unset;
      }
      @include screen-xl {
      }
      @include screen-xxl {
        width: 45%;
      }
      img {
        width: 96px;
        margin-bottom: 16px;
        @include screen-sm {
        }
      }
    }
    &__dt-graph.report {
      img {
        width: 80px;
      }
    }
    &__phases {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(2, 1fr);
      margin-top: 1rem;
      @include screen-sm {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 1.5rem;
      }
      @include screen-md {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: repeat(2, 1fr);
        margin-top: 0;
        width: 47%;
      }
      @include screen-xl {
        order: 2;
        width: 63%;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      @include screen-xxl {
        order: 3;
        width: 54%;
      }
    }
    &__phases.report {
      order: 3;
      width: 50%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    &__phase-image {
      width: 89px;
      margin: auto;
      @include screen-sm {
        width: 105px;
      }
      @include screen-md {
        width: 122px;
      }
      @include screen-xl {
        width: 131px;
        margin: 0 1rem;
      }
      @include screen-xxl {
        width: 169px;
        margin: 0 16px;
      }
    }
    &__phase-image.report {
      img {
        width: 120px;
        margin: 0 16px;
      }
    }
  }
</style>
